import { withForm } from '@/components/form';
import { SectionCard } from '@/components/ui';

import type { ReferenceFormItem } from '../../contactSchema';
import { defaultFormValues, referenceRelationshipEnum } from '../../contactSchema';
import { AddItemButton, RepeaterItem } from './RepeaterItem';

const titleCase = (s: string) => (s ? s[0].toUpperCase() + s.slice(1) : s);

const RELATIONSHIP_OPTIONS = [
  { value: '', label: '—' },
  ...referenceRelationshipEnum.options
    .filter((v) => v !== '')
    .map((v) => ({ value: v, label: titleCase(v) })),
];

const empty = (): ReferenceFormItem => ({ name: '' });

export const ReferencesSection = withForm({
  defaultValues: defaultFormValues,
  render: function ReferencesSection({ form }) {
    return (
      <SectionCard
        title="References"
        actions={<AddItemButton onClick={() => form.pushFieldValue('references', empty())} />}
      >
        <form.AppField name="references">
          {(field) => (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {(field.state.value ?? []).map((_, i) => (
                <RepeaterItem key={i} onRemove={() => field.removeValue(i)} removeLabel="Remove reference">
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    <form.AppField name={`references[${i}].name`}>
                      {(f) => <f.TextField label="Name" required />}
                    </form.AppField>
                    <div className="ds-form-grid-3">
                      <form.AppField name={`references[${i}].relationship`}>
                        {(f) => <f.Select label="Relationship" options={RELATIONSHIP_OPTIONS} />}
                      </form.AppField>
                      <form.AppField name={`references[${i}].position`}>
                        {(f) => <f.TextField label="Position" />}
                      </form.AppField>
                      <form.AppField name={`references[${i}].organization`}>
                        {(f) => <f.TextField label="Organization" />}
                      </form.AppField>
                    </div>
                    <div className="ds-form-grid-2">
                      <form.AppField name={`references[${i}].email`}>
                        {(f) => <f.TextField label="Email" type="email" />}
                      </form.AppField>
                      <form.AppField name={`references[${i}].phone`}>
                        {(f) => <f.TextField label="Phone" />}
                      </form.AppField>
                    </div>
                  </div>
                </RepeaterItem>
              ))}
            </div>
          )}
        </form.AppField>
      </SectionCard>
    );
  },
});
